import BaseProxy from './Base';

class FilesProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('files', parameters, 'api/v1');
  }

  changeName({ id, name }) {
    this.endpoint = `${this.endpoint}/${id}/name`;
    return this.create({ name });
  }

  changeDetails({ id, details }) {
    this.endpoint = `${this.endpoint}/${id}/details`;
    return this.create({ ...details });
  }

  changeClusters({ id, params }) {
    this.endpoint = `${this.endpoint}/${id}/detected_outfits`;
    return this.submit('post', `/${this.endpoint}`, params);
  }

  deleteLogs({ job_id, ids }) {
    this.endpoint = `${this.endpoint}/${job_id}/task_statuses`;
    return this.submit('delete', `/${this.endpoint}`, { files_ids: ids });
  }

  getClusters({ id, ...parameters }) {
    this.setParameters(parameters);
    this.endpoint = `${this.endpoint}/${id}/detected_outfits`;
    return this.load();
  }

  getFiles(query) {
    const parameters = {};
    if (!Object.prototype.hasOwnProperty.call(query, 'page')) {
      parameters.page = 1;
    } else {
      parameters.page = query.page;
    }
    if (!Object.prototype.hasOwnProperty.call(query, 'limit')) {
      parameters.limit = 30;
    } else {
      parameters.limit = query.limit;
    }
    if (Object.prototype.hasOwnProperty.call(query, 'column')) {
      parameters.order = `${query.order === 'descending' ? '-' : ''}${query.column}`;
    } else {
      parameters.order = '-created_at';
    }
    if (Object.prototype.hasOwnProperty.call(query, 'filter')) {
      parameters.q = query.filter;
    }
    this.setParameters(parameters);
    return this.load();
  }

  getFrames(fileId) {
    this.endpoint = `api/v1/frames/${fileId}/status`;
    return this.load();
  }

  getPossibleFps() {
    this.endpoint = `${this.endpoint}/possible_fps`;
    return this.load();
  }

  getStatuses(jobId) {
    this.endpoint = `${this.endpoint}/${jobId}/task_statuses`;
    return this.load();
  }

  setFps({ id, params }) {
    this.endpoint = `${this.endpoint}/${id}/fps`;
    return this.submit('put', `/${this.endpoint}`, params);
  }

  search(keyword) {
    this.setParameter('q', keyword);
    return this.load();
  }

  // run({ id: jobId, formData }) {
  //   this.endpoint = `${this.endpoint}/${jobId}`;
  //   return this.create(formData);
  // }

  delete(filesIds) {
    const ids = Array.isArray(filesIds) ? filesIds : [filesIds];
    return this.submit('delete', `/${this.endpoint}`, { files_ids: ids });
  }

  uploadFromUrl(url) {
    if (!url || typeof url !== 'string') return
    this.endpoint = `${this.endpoint}/clouds/public_urls`;
    return this.create({url});
  }

  startAnalyzeOutfits({ id }) {
    this.endpoint = `${this.endpoint}/${id}/analyze_outfits`;
    return this.create();
  }

  updateFrames(file_id) {
    this.endpoint = `${this.endpoint}/${file_id}/frames`;
    return this.submit('put', `/${this.endpoint}`);
  }
}

export default FilesProxy;
